module.exports = __webpack_public_path__ + "a467b622c36372e93bdc10cf88104980.png";